const DEG_TO_RAD = Math.PI / 180;
const MAX_NUM = Number.MAX_VALUE;
const MIN_NUM = -Number.MAX_VALUE;

export { DEG_TO_RAD, MAX_NUM, MIN_NUM };